import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  model,
} from '@angular/core';

import { copyToClipboard, IconModule } from '@hglobal/fin-ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from 'app/common/button';

import { SecureCardDetails } from '@iw/cards';
import { CardViewAction, CardViewSize } from '@iw/common';
import { CardNumberPipe } from '@iw/core/pipes';
import { GlobalToastService } from '@iw/core/services';

import { ShimmerComponent } from '../../shimmer/shimmer.component';

@Component({
  selector: 'iw-bank-card-back',
  imports: [
    ButtonComponent,
    IconModule,
    TranslateModule,
    ShimmerComponent,
    DatePipe,
    CardNumberPipe,
  ],
  templateUrl: './bank-card-back.component.html',
  styleUrl: './bank-card-back.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BankCardBackComponent {
  readonly #toast = inject(GlobalToastService);
  readonly #translate = inject(TranslateService);

  readonly sensitiveData = input<SecureCardDetails>();
  readonly size = input<CardViewSize>();
  readonly iconSize = input<Record<CardViewSize, number>>();
  readonly actions = input<CardViewAction[]>();
  readonly isSensitiveDataHidden = model(true);
  readonly isLoading = input(false);

  toggleSensitiveData(): void {
    this.isSensitiveDataHidden.update((v) => !v);
  }

  async copy(value: string, translate: string, event: Event) {
    event.stopPropagation();
    await copyToClipboard(value);
    this.#toast.showSuccess(
      this.#translate.instant(`clipboard.${translate}.copied`),
    );
  }
}
